import { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'state/store';
import { selectStageById } from 'state/ProjectsList/include/stagesSlice';

interface ProcessStageProps {
  stage: string;
}

const ProcessStage: FC<ProcessStageProps> = ({ stage }) => {
  const stageData = useSelector((state: RootState) =>
    selectStageById(state, stage)
  );

  if (!stageData) {
    return null;
  }
  return <>{stageData.name}</>;
};

export default ProcessStage;
